import styled from "styled-components";

export const Title = styled.h1`
  font-weight: 200;
  font-size: 40px;
  margin: 0px;
  color: #ffffff;
  text-align: left;
  margin-bottom: 40px;
  line-height: 69px;

  span {
    color: #4162fd;
  }
`;

export const Subtitle = styled.div`
  font-size: 20px;
  font-weight: 200;
  line-height: 30px;
  color: #ffffff;
  margin-bottom: 50px;
  text-align: left;
`;

export const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  float: right;

  /* HD: largura total */
  @media (min-width: 1280px) and (max-width: 1919px) {
    max-width: 100%;
  }

  /* Full HD: 80% */
  @media (min-width: 1920px) {
    max-width: 80%;
  }
`;
